<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div class="ts-grid ts-grid-cols-2 ts-gap-2">
      <div>
        <label class="required">{{ $t('saleContract.paymentExpired') }}</label>
        <a-date-picker
          v-model="model.payment_expiry_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          :disabled="model.credit_day > 0"
          class="ts-w-full"
        ></a-date-picker>
        <div class="validate" v-if="errors.has('payment_expiry_date')">
          {{ errors.first('payment_expiry_date') }}
        </div>
      </div>
      <div>
        <label class="required">{{ $t('saleContract.deliveryDate') }}</label>
        <a-date-picker
          v-model="model.expected_delivery_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          class="ts-w-full"
        ></a-date-picker>
        <div class="validate" v-if="errors.has('expected_delivery_date')">
          {{ errors.first('expected_delivery_date') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'paymentDate',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>